"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIZE_SEARCH_TYPE_LABEL = exports.PRIZE_SEARCH_TYPE = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'prize-container';
exports.CHILD = 'prize-container/item';
exports.PRIZE_SEARCH_TYPE = {
    ByRule: 'by_rule',
    ById: 'by_id'
};
exports.PRIZE_SEARCH_TYPE_LABEL = {
    [exports.PRIZE_SEARCH_TYPE.ByRule]: '规则',
    [exports.PRIZE_SEARCH_TYPE.ById]: '奖项'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxpQkFBaUIsQ0FBQztBQUN6QixRQUFBLEtBQUssR0FBRyxzQkFBc0IsQ0FBQztBQUUvQixRQUFBLGlCQUFpQixHQUFHO0lBQzdCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLElBQUksRUFBRSxPQUFPO0NBQ2hCLENBQUM7QUFFVyxRQUFBLHVCQUF1QixHQUFHO0lBQ25DLENBQUMseUJBQWlCLENBQUMsTUFBTSxDQUFDLEVBQUUsSUFBSTtJQUNoQyxDQUFDLHlCQUFpQixDQUFDLElBQUksQ0FBQyxFQUFFLElBQUk7Q0FDakMsQ0FBQyJ9